import api from "../api/axios";
import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export interface CreateEmpTypePayload {
  name: string;
  status: number;
}

export interface UpdateEmpTypePaylod extends CreateEmpTypePayload {}

export const EMPTYPE_QUERY_KEY = ["employment-types"];
export const VIEW_EMPTYPE_QUERY_KEY = ["view-employment-types"];

export const employmentTypeService = {
  createEmploymentType: async (payload: CreateEmpTypePayload) => {
    return requestWithRefresh(async () => {
      const response = await api.post("api/employment-types", payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  showEmploymentType: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/employment-types/${id}`, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  updateEmploymentType: async (id: number, payload: UpdateEmpTypePaylod) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(`api/employment-types/${id}`, payload, {
        headers: getAuthHeaders(),
      });

      return response.data;
    });
  },

  toggleStatus: async (id: number) => {
    return requestWithRefresh(async () => {
      const response = await api.patch(
        `api/employment-types/${id}/toggle-status`,
        {},
        {
          headers: getAuthHeaders(),
        },
      );

      return response.data;
    });
  },

  viewAllEmploymentType: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/view-employment-types`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
};
